import React, { useState, useEffect } from "react";
import { addData } from "../../../lib/taskm";
import { getInstructorStudent } from "../../../lib/instructorstudentview";
import { getInstructorIdData } from "../../../lib/classview";
import { getDataWithClass } from "../../../lib/classdetailview";
import { TaskTopic911Select, TaskTopic12Select } from "../../ui/myselect";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../usercontext";
import TextEditor from "../../ui/editor";

export default function TaskManage() {
  const [selectedStudent, setSelectedStudent] = useState("All");
  const [selectedClass, setSelectedClass] = useState("");
  const [desc, setDesc] = useState();
  const [category, setCategory] = useState("Student");
  const [topicType, setTopicType] = useState("Grade911");
  const [instructorStudent, setInstructorStudent] = useState([]);
  const [instructorClass, setInstructorClass] = useState([]);
  const [classDetail, setClassDetail] = useState([]);
  const [taskTopic, setTaskTopic] = useState(null);
  const { profile } = useAuth();
  const navigate = useNavigate();
  const [date, setDate] = useState();

  const getCurrentDateInput = () => {
    const dateObj = new Date();
    const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    const day = ("0" + dateObj.getDate()).slice(-2);
    const year = dateObj.getFullYear();
    const shortDate = `${year}-${month}-${day}`;
    setDate(shortDate);
  };

  async function GetInstructorStudentData(id) {
    const students = await getInstructorStudent(id);
    setInstructorStudent(students);

    const clas = await getInstructorIdData(id);
    setInstructorClass(clas);
    setSelectedClass(clas[0].id);
  }

  async function GetClassDetail() {
    if (selectedClass) {
      const classinfo = await getDataWithClass(selectedClass, profile.id);
      setClassDetail(classinfo);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (category === "Student") {
      if (selectedStudent === "All") {
        instructorStudent.map(async function (data) {
          await addData({
            from: data.instructorId,
            to: data.studentId,
            subject: taskTopic,
            setDate: date,
            desc: desc,
          });
        });
      } else {
        await addData({
          from: profile.id,
          to: selectedStudent,
          subject: taskTopic,
          setDate: date,
          desc: desc,
        });
      }
    } else {
      classDetail.map(async function (data) {
        await addData({
          from: data.instructorId,
          to: data.studentId,
          subject: taskTopic,
          desc: desc,
        });
      });
    }

    navigate("/instructor/instructor-taskmanage");
  };

  useEffect(() => {
    getCurrentDateInput();
    GetInstructorStudentData(profile.id);
  }, []);

  useEffect(() => {
    GetClassDetail();
    getCurrentDateInput();
  }, [selectedClass]);

  return (
    <>
      <div className="settings-widget profile-details">
        <div className="settings-menu p-2">
          <div className="profile-heading p-2">
            <h3>New Item</h3>
          </div>
          <div className="checkout-form personal-address add-course-info">
            <form role="form" onSubmit={handleSubmit}>
              <div className="row d-flex justify-content-center">
                <div className="col-9 ">
                  <div className="form-group d-flex justify-content-around">
                    <div
                      className="form-check fs-4"
                      style={{ marginRight: "30px" }}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        name="category"
                        id="flexRadioDefault1"
                        value="Student"
                        checked={category === "Student"}
                        onChange={(e) => setCategory("Student")}
                      />
                      <label
                        className="form-check-label fs-4"
                        htmlFor="flexRadioDefault1"
                      >
                        Student
                      </label>
                    </div>
                    <div className="form-check fs-3">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="category"
                        id="flexRadioDefault2"
                        value="Class"
                        checked={category === "Class"}
                        onChange={(e) => setCategory("Class")}
                      />
                      <label
                        className="form-check-label fs-4"
                        htmlFor="flexRadioDefault2"
                      >
                        Class
                      </label>
                    </div>
                  </div>
                </div>
                {category === "Student" ? (
                  <div className="col-9">
                    <div className="form-group">
                      <div>
                        <label>Students</label>
                        <div className="select-container">
                          <select
                            value={selectedStudent}
                            onChange={(e) => setSelectedStudent(e.target.value)}
                            className="select-box"
                          >
                            <option key="aa" value="All">
                              All
                            </option>
                            {instructorStudent.map(function (data, ix) {
                              return (
                                <option key={ix} value={data.studentId}>
                                  {data.name + " " + data.surname}
                                </option>
                              );
                            })}
                          </select>
                          <div className="icon-container">
                            <i className="fa-solid fa-chevron-down"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="col-9">
                    <div className="form-group">
                      <div>
                        <label>Class</label>
                        <div className="select-container">
                          <select
                            value={selectedClass}
                            onChange={(e) => setSelectedClass(e.target.value)}
                            className="select-box"
                          >
                            {instructorClass.map(function (data, ix) {
                              return (
                                <option key={ix} value={data.id}>
                                  {data.class_name}
                                </option>
                              );
                            })}
                          </select>
                          <div className="icon-container">
                            <i className="fa-solid fa-chevron-down"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-9">
                  <label className="form-control-label">Topic</label>
                  <div className="form-group d-flex justify-content-around">
                    <div
                      className="form-check fs-5"
                      style={{ marginRight: "30px" }}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        name="topicType"
                        id="flexRadioDefault1"
                        value="Student"
                        checked={topicType === "Grade911"}
                        onChange={(e) => setTopicType("Grade911")}
                      />
                      <label
                        className="form-check-label fs-6"
                        htmlFor="flexRadioDefault1"
                      >
                        Grade 9-11
                      </label>
                    </div>
                    <div className="form-check fs-5">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="topicType"
                        id="flexRadioDefault2"
                        value="Class"
                        checked={topicType === "Grade12"}
                        onChange={(e) => setTopicType("Grade12")}
                      />
                      <label
                        className="form-check-label fs-6"
                        htmlFor="flexRadioDefault2"
                      >
                        Grade 12
                      </label>
                    </div>
                  </div>
                  <div className="form-group">
                    {topicType === "Grade911" ? (
                      <TaskTopic911Select
                        value={taskTopic}
                        setValue={setTaskTopic}
                      />
                    ) : (
                      <TaskTopic12Select
                        value={taskTopic}
                        setValue={setTaskTopic}
                      />
                    )}
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group w-50">
                    <label className="form-control-label">Date</label>
                    <input
                      type="date"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">Description</label>
                    <div id="editor" >
                      <TextEditor value={desc} setValue={setDesc} />
                    </div>
                  </div>
                </div>
                <div className="update-profile d-flex justify-content-between">
                  <button type="submit" className="btn btn-primary">
                    Add Item
                  </button>
                  <button
                    onClick={() => navigate(-1)}
                    className="btn btn-black btn-sm"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
